import ReactEChartsCore from 'echarts-for-react/lib/core';
import {
  echarts,
  baseChartOptions,
  USER_ROLE_COLORS,
  USER_ROLE_LABELS,
} from '../shared/echarts-config';
import { ChartContainer } from '../shared/ChartContainer';
import { EmptyState } from '../shared/EmptyState';
import type { LoginTrendPoint } from '../../../types/analytics.types';

type LoginTrendChartProps = {
  data: LoginTrendPoint[];
};

const ROLE_KEYS = [
  'CARE_SEEKER',
  'FINANCIAL_ADVISOR',
  'SERVICE_PROVIDER',
  'ADMIN',
] as const;

const buildChartOptions = (data: LoginTrendPoint[]) => ({
  ...baseChartOptions,
  legend: {
    data: ROLE_KEYS.map((key) => USER_ROLE_LABELS[key]),
    bottom: 0,
    textStyle: { fontSize: 12, color: '#6b7280' },
  },
  grid: { ...baseChartOptions.grid, bottom: '12%' },
  xAxis: {
    type: 'category' as const,
    data: data.map((p) => p.date),
    axisLabel: {
      formatter: (value: string) => {
        const d = new Date(value);
        return `${d.getUTCMonth() + 1}/${d.getUTCDate()}`;
      },
      fontSize: 12,
      color: '#6b7280',
    },
    axisLine: { lineStyle: { color: '#e5e7eb' } },
  },
  yAxis: {
    type: 'value' as const,
    axisLabel: { fontSize: 12, color: '#6b7280' },
    splitLine: { lineStyle: { color: '#f3f4f6' } },
  },
  series: ROLE_KEYS.map((role) => ({
    name: USER_ROLE_LABELS[role],
    type: 'bar' as const,
    stack: 'logins',
    data: data.map((p) => p[role]),
    itemStyle: { color: USER_ROLE_COLORS[role] },
  })),
});

export const LoginTrendChart = ({ data }: LoginTrendChartProps) => {
  if (data.length === 0) {
    return (
      <ChartContainer
        title="Login Trend"
        subtitle="Daily logins by user type over the selected period"
      >
        <EmptyState message="No login data available for the selected date range." />
      </ChartContainer>
    );
  }

  return (
    <ChartContainer
      title="Login Trend"
      subtitle="Daily logins by user type over the selected period"
    >
      <ReactEChartsCore
        echarts={echarts}
        option={buildChartOptions(data)}
        style={{ height: 320 }}
        notMerge
        lazyUpdate
      />
    </ChartContainer>
  );
};
